import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const HomeSlider = () => {
  useEffect(() => {
    const carousel = new window.bootstrap.Carousel(
      document.querySelector("#carouselExampleCaptions")
    );
    carousel.cycle(); // Start the carousel
  }, []);

  return (
    <div className="slider-sec">
      <div
        id="carouselExampleCaptions"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="3000">
            <img
              src="https://webapi.entab.info/api/image/SFSAP/public/Images/slide6.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://webapi.entab.info/api/image/SFSAP/public/Images/slide5.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://webapi.entab.info/api/image/SFSAP/public/Images/slide4.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://webapi.entab.info/api/image/SFSAP/public/Images/slide3.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://webapi.entab.info/api/image/SFSAP/public/Images/slide2.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://webapi.entab.info/api/image/SFSAP/public/Images/slide1.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://webapi.entab.info/api/image/SFSAP/public/Images/slide.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://webapi.entab.info/api/image/SFSAP/public/Images/slide7.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://webapi.entab.info/api/image/SFSAP/public/Images/slide8.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://webapi.entab.info/api/image/SFSAP/public/Images/slide9.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSlider;
